import { createElement, forwardRef } from 'react';
import * as icons from '@ant-design/icons';
const createFromIconfontCN = icons.createFromIconfontCN;
const Icon = (props, ref) => {
    const { type = '', size, color, ...rest } = props;
    const IconComp = (icons || {})[type];
    const style = {
        ...rest.style,
        fontSize: size,
        color,
    };
    if (!IconComp) {
        const IconFont = createFromIconfontCN();
        return createElement(IconFont, { type: type, ...rest, style: style, ref: ref });
    }
    return createElement(IconComp, { ...rest, style: style, twoToneColor: color, ref: ref });
};
export default forwardRef(Icon);
